/**
 * Tipos de coletor
 * @enum {typeof EnumTiposDeColetor[keyof typeof EnumTiposDeColetor]}
 */
export const EnumTiposDeColetor = Object.freeze({
    ArmazemGeral: "01",
    Entreposto: "02",
    Reconhecimento: "03"
});
